import styled from "styled-components";

export const CategoryListContainer = styled.div``;